export default (() => {
  $('.tiles-gallery .image').click(function() {
    var galleryToOpen = $(this).data('gallery');

    $(`.gallery-popup-outer[data-gallery="${galleryToOpen}"]`).css('display', 'flex');
  })

  $('.tiles-gallery .change-description').click(function() {
    $('.tile-content.current').removeClass('current');
    $('.tiles-titles li.current').removeClass('current');

    var descriptionToOpen = $(this).data('description');

    $(`.tiles-titles li[data-description="${descriptionToOpen}"]`).addClass('current');
    $(`.tile-content[data-description="${descriptionToOpen}"]`).addClass('current');
  })
});



// WEBPACK FOOTER //
// ./scripts/components/tiles-gallery.js